
























import * as graphSdk from '@/api/graphql-sdk.generated'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { NestedResponses, DoubleNestedResponses } from '../Utilities/ChartUtilities'
import { Response, Question } from '@/store/modules/survey-store-module'
import OpenEnd from './OpenEnd.vue'
import store from '@/store'
import { QuestionType } from '@shared/types/database'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import { getOpenEnd } from '../Utilities/SurveyUtilities'

@Component({
  components: {
    OpenEnd,
    LoadingIndicator
  }
})
export default class BroadSearchResults extends Vue {
  @Prop({ required: true }) advancedResults!: graphSdk.SearchResponsesQuery['searchResponses']
  @Prop({ required: true }) openEndResponses!: Response[] | NestedResponses | DoubleNestedResponses
  @Prop({ required: true }) question!: Question
  @Prop({ required: false, default: () => '' }) searchTerm!: string
  @Prop({ required: false, default: () => false }) loading!: boolean

  get flatResponses () {
    let responses: Array<Response & { categories?: string[] }>
    if (Array.isArray(this.openEndResponses)) {
      responses = this.openEndResponses
    } else if (Object.values(this.openEndResponses).some(value => Array.isArray(value))) { // object values are response arrays
      responses = this.getResponsesFromResponseSet(this.openEndResponses as NestedResponses)
    } else { // only thing left is max dimensions, two levels deep
      responses = Object.entries(this.openEndResponses).reduce((acc: Array<Response & { categories: string[]}>, [category, nestedResponses]: [string, NestedResponses]) => {
        const responses = this.getResponsesFromResponseSet(nestedResponses, category)
        return acc.concat(responses)
      }, [])
    }
    return responses
  }

  getResponsesFromResponseSet (nestedResponses: Record<string, Response[]>, secondCategory?: string) {
    return Object.entries(nestedResponses).reduce((acc: Array<Response & { categories: string[] }>, [category, responseSet]: [string, Response[]]) => {
      category = this.getCategoryText(category)
      const responses = responseSet.map(response => {
        const categories = [category]
        if (secondCategory) categories.unshift(secondCategory)
        return {
          categories,
          ...response
        }
      })
      return acc.concat(responses)
    }, [])
  }

  getCategoryText (category: string) {
    if (!isNaN(parseInt(category))) {
      category = 'Scale Rating: ' + category
    }
    return category
  }

  get visibleResponseIdSet () {
    return new Set(this.flatResponses.map(response => response.id))
  }

  get respondentResponseMap () {
    return this.flatResponses.reduce((acc: Record<string, { respondent: graphSdk.Respondent, response: Response & { categories?: string[] }}>, response) => {
      if (!response.respondentSurveyId) {
        console.error('respondent id not here')
      }
      acc[response.id] = {
        response,
        respondent: store.getters.survey.respondentById(response.respondentSurveyId!)
      }
      return acc
    }, {})
  }

  get searchResults () {
    const filtered = this.advancedResults?.hits.filter(hit => {
      return this.visibleResponseIdSet.has(hit._id)
    })
    return filtered?.map(hit => {
      const { respondent, response } = this.respondentResponseMap[hit._id]
      const text = this.responseText(response, hit.highlight?.text[0])
      const tags = response.categories?.map(category => ({
        value: category,
        color: '',
        background: ''
      })) || []
      // tags.push({
      //   value: hit._score.toString(),
      //   color: '',
      //   background: ''
      // })
      return {
        text,
        respondent: respondent,
        tags,
        score: hit._score
      }
    })
  }

  responseText (response: Response, overrideValue?: string): string {
    const responseText = overrideValue || getOpenEnd(response, this.question) || 'Missing text answer'
    return responseText
  }

  get isTextArea () {
    return this.question.type === QuestionType.TextArea
  }
}
